class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);

      // Sync timer UI after drawer content re-renders
      if (timeInSeconds > 0) {
        syncTimerUI();
      }
      
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);

        // Sync timer UI after drawer content re-renders
        if (timeInSeconds > 0) {
          syncTimerUI();
        }
        
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // Sync timer UI after drawer content re-renders
    if (timeInSeconds > 0) {
      syncTimerUI();
    }
    
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      // Sync timer UI after drawer content re-renders
      if (timeInSeconds > 0) {
        syncTimerUI();
      }

      // Sync freebie after drawer content re-renders
      freebieUpdate();
      
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

//----cart timer code starts----//
let countdownInterval;
let timeInSeconds = 0; // Global timer state
let timerMessageEl = document.querySelector('.cstm_drawer_header_timer_msg');
let timerMessageEl_time = document.querySelector('.cstm_drawer_header_timer .timer_msg_expire_time');
const addToCartButtons = document.querySelectorAll('.cstm_add_to_cart');
const expireTime = parseInt(timerMessageEl?.dataset.expireTime, 10) || 0;
// Restore previous state
const savedTime = parseInt(localStorage.getItem('timeInSeconds'), 10);
const savedMessage = localStorage.getItem('timerMessage');
const consentData = JSON.parse(localStorage.getItem('cookieConsent'));
// Show saved message and resume timer if valid
if (timerMessageEl) {
  if (savedMessage) {
    timerMessageEl.textContent = savedMessage;
    timerMessageEl.style.display = 'block';
  }
  if (!isNaN(savedTime) && savedTime > 0 && consentData && Date.now() < consentData.expiresAt) {
    timeInSeconds = savedTime;
    syncTimerUI();
    startCountdown();
  }
}
// Funcation to update timer text and save to localStorage
function syncTimerUI() {
  timerMessageEl = document.querySelector('.cstm_drawer_header_timer_msg'); // Re-select in case the drawer is rendered after click
  timerMessageEl_time = document.querySelector('.cstm_drawer_header_timer .timer_msg_expire_time'); // Re-select in case the drawer is rendered after click
  if (!timerMessageEl) return;
  timerMessageEl.style.display = 'block';
  const consent = JSON.parse(localStorage.getItem('cookieConsent'));
  if (!consent || Date.now() >= consent.expiresAt || timeInSeconds <= 0) {
    const expiredMsg = "Your cart has expired.";
    const expiredTimeInSeconds = 0;
    timerMessageEl.textContent = expiredMsg;
    localStorage.setItem('timerMessage', expiredMsg);
    localStorage.setItem('timeInSeconds', expiredTimeInSeconds);
    timerMessageEl_time.style.display = 'none';
    return;
  }
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  let time = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} mins.`;
  // const msg = `Hurry now! Your cart will expire in ${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} mins.`;
  const msg = `Hurry now! Your cart will expire in `;
  timerMessageEl.textContent = msg;
  // localStorage.setItem('timerMessage', msg);
  timerMessageEl_time.textContent = time;
  localStorage.setItem('timerMessage', time);
}
// Function to start countdown ticking
function startCountdown() {
  if (countdownInterval) clearInterval(countdownInterval);
  countdownInterval = setInterval(() => {
    if (timeInSeconds > 0) {
      timeInSeconds--;
      localStorage.setItem('timeInSeconds', timeInSeconds);
    }
    syncTimerUI();
    if (timeInSeconds <= 0) clearInterval(countdownInterval);
  }, 1000);
}
// Start timer on .cstm_add_to_cart click
if (timerMessageEl && addToCartButtons.length && expireTime > 0) {
  addToCartButtons.forEach(button => {
    button.addEventListener('click', () => {
      const expiresAt = Date.now() + (30 * 24 * 60 * 60 * 1000); // 30 days
      localStorage.setItem('cookieConsent', JSON.stringify({
        accepted: true
        , expiresAt
      }));
      if (timeInSeconds <= 0) {
        timeInSeconds = expireTime * 60;
        localStorage.setItem('timeInSeconds', timeInSeconds);
      }
      syncTimerUI(); // Show message immediately
      startCountdown(); // Start countdown ticking
      setTimeout(syncTimerUI, 300); // Optionally re-apply after small delay if drawer opens dynamically
    });
  });
} else {
  console.log('Required elements not found or invalid expire time.');
}
//----cart timer code ends----//

/*-------cart freebie product add code starts------*/ 
function freebieUpdate() {
  console.log("freebieUpdate function call");
  // addFreebie();
  // add_PO3_Freebie();
  // add_novology_freebie();
  update_Cart_weight()
}

const cstmCartDrawerWrapper = document.getElementById('CartDrawer');
// function addFreebie() {
//   console.log("addFreebie function call");
//   cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
//   const freebieElement = document.getElementById('cart_freebie_variant_id');
//   const mainProductElement = document.getElementById('cart_freebie_main_product_variant_id');
//   if (!freebieElement || !mainProductElement) return;
//   const freebieVariantId = freebieElement.dataset.variantId;
//   const mainVariantIds = mainProductElement.dataset.variantId.split(',');
//   fetch('/cart.js').then(res => res.json()).then(cart => {
//     const hasMainVariant = cart.items.some(item => mainVariantIds.includes(item.variant_id.toString()));
//     const hasFreebie = cart.items.some(item => item.variant_id.toString() === freebieVariantId);
//     if (hasMainVariant && !hasFreebie) {
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: parseInt(freebieVariantId),
//           quantity: 1
//         })
//       }).then(res => res.json()).then(() => setTimeout(updateCartSection, 100)).catch(error => console.error('Error adding freebie:', error));
//     }
//     setTimeout(() => {
//       if (typeof updateCartSection === 'function') updateCartSection();
//       cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//     }, 2500);
//   }).catch(error => console.error('Error fetching cart:', error));
// }

// function add_PO3_Freebie() {
//   console.log("add_PO3_Freebie function call");
//   cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
//   const po3_freebieElement = document.getElementById('cart_PO3_variant_id');
//   const po3_mainProductElement = document.getElementById('cart_PO3_main_product_variant_id');
//   if (!po3_freebieElement || !po3_mainProductElement) return;
//   const freebieVariantId = po3_freebieElement.dataset.variantId;
//   const mainVariantIds = po3_mainProductElement.dataset.variantId.split(',');
//   fetch('/cart.js').then(res => res.json()).then(cart => {
//     const hasMainVariant = cart.items.some(item => mainVariantIds.includes(item.variant_id.toString()));
//     const hasFreebie = cart.items.some(item => item.variant_id.toString() === freebieVariantId);
//     if (hasMainVariant && !hasFreebie) {
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: parseInt(freebieVariantId),
//           quantity: 1
//         })
//       }).then(res => res.json()).then(() => setTimeout(updateCartSection, 100)).catch(error => console.error('Error adding freebie:', error));
//     }
//     setTimeout(() => {
//       if (typeof updateCartSection === 'function') updateCartSection();
//       cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//     }, 2000);
//   }).catch(error => console.error('Error fetching cart:', error));
// }

// function add_novology_freebie() {
//   console.log("add_novology_freebie function call");
//   cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
//   const novology_freebieElement = document.getElementById('cart_novology_variant_id');
//   const novology_mainProductElement = document.getElementById('cart_novology_main_product_variant_id');
//   if (!novology_freebieElement || !novology_mainProductElement) return;
//   const novology_freebieVariantId = novology_freebieElement.dataset.variantId;
//   const novology_mainVariantIds = novology_mainProductElement.dataset.variantId.split(',');
//   fetch('/cart.js').then(res => res.json()).then(cart => {
//     const novology_hasMainVariant = cart.items.some(item => novology_mainVariantIds.includes(item.variant_id.toString()));
//     const novology_hasFreebie = cart.items.some(item => item.variant_id.toString() === novology_freebieVariantId);
//     if (novology_hasMainVariant && !novology_hasFreebie) {
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: parseInt(novology_freebieVariantId),
//           quantity: 1
//         })
//       }).then(res => res.json()).then(() => setTimeout(updateCartSection, 100)).catch(error => console.error('Error adding freebie:', error));
//     }
//     setTimeout(() => {
//       if (typeof updateCartSection === 'function') updateCartSection();
//       cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//     }, 2500);
//   }).catch(error => console.error('Error fetching cart:', error));
// }


//-----BAU Freebie code starts here----//
window.update_Cart_weight = async function() {
  cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
  try {
    const res = await fetch('/cart.json');
    const data = await res.json();

    const free_gift_box_1 = 47769184993534; // Novology Sunscreen Sample
    const free_gift_box_2 = 47121069048062; // LIV Sipper
    const free_gift_box_3 = 47457065173246; // LIV Festive Kit
    const free_gift_box_4 = 47401068691710; // LIV Chiller
    const cartTotal = data.total_price / 100;
    const giftIds = [free_gift_box_1, free_gift_box_2, free_gift_box_3, free_gift_box_4];

    //-----remove free gift if cart has only sugar free products code starts----//
    // const sugarFreeProductIds = [
    //   47862502719742,
    //   47862460481790,
    //   47862339109118,
    //   47862250963198,
    //   47862182904062,
    //   47862055960830
    // ];
    // // Exclude existing free gifts
    // const nonGiftItems = data.items.filter(item => !item.properties?.free_gift);
    // // Check if the cart has **only sugar-free products**
    // const onlySugarFree = nonGiftItems.length > 0 && nonGiftItems.every(item => sugarFreeProductIds.includes(item.id));
    // if (onlySugarFree) {
    //   console.log("Cart has only sugar-free products → No free gift allowed");
    //   // ❌ Remove any existing free gifts
    //   const removeGiftPromises = data.items.filter(item => item.properties?.free_gift).map(item => fetch('/cart/change.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Accept': 'application/json'
    //     },
    //     body: JSON.stringify({
    //       id: item.key,
    //       quantity: 0
    //     })
    //   }));
    //   await Promise.all(removeGiftPromises);
    //   // ✅ Update cart UI
    //   if (typeof updateCartSection === 'function') updateCartSection();
    //   cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
    //   return; // 🔴 Stop further gift logic
    // }
    //-----remove free gift if cart has only sugar free products code ends----//

    const findItemKeyById = (variantId) => {
      const match = data.items.find(
        (item) => item.id === variantId && item.properties?.free_gift !== undefined);
      return match ? match.key : null;
    };
    const giftItemsInCart = data.items.filter(
      (item) => giftIds.includes(item.id) && item.properties?.free_gift !== undefined);
    if (data.items.length > 0 && giftItemsInCart.length === data.items.length) {
      console.log("Cart contains only gift items → clearing entire cart...");
      await fetch('/cart/clear.js', {
        method: 'POST'
      });
      setTimeout(() => {
        if (typeof updateCartSection === 'function') updateCartSection();
        cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
      }, 2000);
      return;
    }
    let correctGiftId = null;
    // if (cartTotal > 15000) {
    //   correctGiftId = free_gift_box_4;
    //   console.log("Eligible for above ₹15000 gift");
    // } else 
    if (cartTotal > 3500) {
      correctGiftId = free_gift_box_3;
      console.log("Eligible for ₹6000–₹15000 gift");
    }
    // if (cartTotal > 6000) {
    //   correctGiftId = free_gift_box_3;
    //   console.log("Eligible for above ₹6000");
    // } 
    // else if (cartTotal >= 2399) {
    //   correctGiftId = free_gift_box_2;
    //   console.log("Eligible for ₹2399–₹6000 gift");
    // } 
    // else if (cartTotal > 0) {
    //   correctGiftId = free_gift_box_1;
    //   console.log("Eligible for below ₹2399 gift");
    // } 
    else {
      console.log("Cart is empty → No gift eligible");
    }
    const itemsToRemove = [];
    const itemsToAdd = [];
    for (const giftItem of giftItemsInCart) {
      if (giftItem.id !== correctGiftId) {
        itemsToRemove.push(giftItem.key);
      }
    }
    const alreadyHasCorrectGift = giftItemsInCart.some(
      (item) => item.id === correctGiftId);
    if (correctGiftId && !alreadyHasCorrectGift) {
      itemsToAdd.push({
        id: correctGiftId,
        quantity: 1,
        properties: {
          free_gift: 'freebie'
        }
      });
    }
    for (const key of itemsToRemove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      });
    }
    if (itemsToAdd.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: itemsToAdd
        })
      });
    }
    setTimeout(() => {
      if (typeof updateCartSection === 'function') updateCartSection();
      cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
    }, 2200);
  } catch (error) {
    console.error('Error updating cart freebies:', error);
  }
};
//-----BAU Freebie code ends here----//

//----May Summer Sale freebie code starts here-----//
// window.update_Cart_weight = async function() {
//   cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
//   try {
//     const res = await fetch('/cart.json');
//     const data = await res.json();
//     const free_gift_box_1 = 48132664918270;
//     const free_gift_box_2 = 48219250589950;
//     const free_gift_box_3 = 48132749066494;
//     const free_gift_box_4 = 48132665540862;
//     const cartTotal = data.total_price / 100;
//     const giftIds = [free_gift_box_1, free_gift_box_2, free_gift_box_3, free_gift_box_4];
    
//     const findItemKeyById = (variantId) => {
//       const match = data.items.find(
//         (item) => item.id === variantId && item.properties?.free_gift !== undefined);
//       return match ? match.key : null;
//     };
//     const giftItemsInCart = data.items.filter(
//       (item) => giftIds.includes(item.id) && item.properties?.free_gift !== undefined);
//     if (data.items.length > 0 && giftItemsInCart.length === data.items.length) {
//       console.log("Cart contains only gift items → clearing entire cart...");
//       await fetch('/cart/clear.js', {
//         method: 'POST'
//       });
//       setTimeout(() => {
//         if (typeof updateCartSection === 'function') updateCartSection();
//         cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//       }, 2500);
//       return;
//     }
//     let eligibleGiftIds = [];
//     if (cartTotal > 4500) {
//       eligibleGiftIds = [
//         free_gift_box_1,
//         free_gift_box_2,
//         free_gift_box_3,
//         free_gift_box_4
//       ];
//       console.log("Eligible for all gifts above ₹4500");
//     } else if (cartTotal > 3200) {
//       eligibleGiftIds = [
//         free_gift_box_1,
//         free_gift_box_2,
//         free_gift_box_3
//       ];
//       console.log("Eligible for all gifts above ₹3200");
//     } else if (cartTotal >= 2399) {
//       eligibleGiftIds = [
//         free_gift_box_1,
//         free_gift_box_2
//       ];
//       console.log("Eligible for ₹2399–₹3200 gifts");
//     } else if (cartTotal > 0) {
//       eligibleGiftIds = [free_gift_box_1];
//       console.log("Eligible for all orders");
//     } else {
//       console.log("Cart is empty → No gift eligible");
//     }
//     console.log("Eligible Gift IDs:", eligibleGiftIds);
//     const itemsToRemove = [];
//     const itemsToAdd = [];
//     // Remove gifts that are not eligible
//     for (const giftItem of giftItemsInCart) {
//       if (!eligibleGiftIds.includes(giftItem.id)) {
//         itemsToRemove.push(giftItem.key);
//       }
//     }
//     // Add missing eligible gifts
//     for (const giftId of eligibleGiftIds) {
//       const alreadyExists = giftItemsInCart.some(
//         (item) => item.id === giftId);
//       if (!alreadyExists) {
//         itemsToAdd.push({
//           id: giftId,
//           quantity: 1,
//           properties: {
//             free_gift: 'freebie'
//           }
//         });
//       }
//     }
//     // Remove unwanted gifts
//     for (const key of itemsToRemove) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           id: key,
//           quantity: 0
//         })
//       });
//     }
//     // Add eligible gifts
//     if (itemsToAdd.length > 0) {
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           items: itemsToAdd
//         })
//       });
//     }
//     setTimeout(() => {
//       if (typeof updateCartSection === 'function') updateCartSection();
//       cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//     }, 2500);
//   } catch (error) {
//     console.error('Error updating cart freebies:', error);
//   }
// };
//----May Summer Sale freebie code ends here-----//

// window.removeFreebie = function() {
//   console.log("removeFreebie function call");
//   cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
//   const freebieElement = document.getElementById('cart_freebie_variant_id');
//   const mainProductElement = document.getElementById('cart_freebie_main_product_variant_id');
//   if (!freebieElement || !mainProductElement) return;
//   const freebieVariantId = freebieElement.dataset.variantId;
//   const mainVariantIds = mainProductElement.dataset.variantId.split(',');
//   setTimeout(function() {
//     fetch('/cart.js').then(res => res.json()).then(cart => {
//       const hasMainVariant = cart.items.some(item => mainVariantIds.includes(item.variant_id.toString()));
//       const hasFreebie = cart.items.some(item => item.variant_id.toString() === freebieVariantId);
//       if (!hasMainVariant && hasFreebie) {
//         const freebieItem = cart.items.find(item => item.variant_id.toString() === freebieVariantId);
//         if (freebieItem) {
//           fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//               id: freebieItem.key,
//               quantity: 0
//             })
//           }).then(res => res.json()).then(() => setTimeout(updateCartSection, 1000)).catch(error => console.error('Error removing freebie:', error));
//         }
//       }
//       setTimeout(() => {
//         if (typeof updateCartSection === 'function') updateCartSection();
//         cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//       }, 3200);
//     }).catch(error => console.error('Error fetching cart:', error));
//   }, 500)
// }

// window.remove_PO3_Freebie = function() {
//   console.log("remove_PO3_Freebie function call");
//   cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
//   const po3_freebieElement = document.getElementById('cart_PO3_variant_id');
//   const po3_mainProductElement = document.getElementById('cart_PO3_main_product_variant_id');
//   if (!po3_freebieElement || !po3_mainProductElement) return;
//   const freebieVariantId = po3_freebieElement.dataset.variantId;
//   const mainVariantIds = po3_mainProductElement.dataset.variantId.split(',');
//   setTimeout(function() {
//     fetch('/cart.js').then(res => res.json()).then(cart => {
//       const hasMainVariant = cart.items.some(item => mainVariantIds.includes(item.variant_id.toString()));
//       const hasFreebie = cart.items.some(item => item.variant_id.toString() === freebieVariantId);
//       if (!hasMainVariant && hasFreebie) {
//         const freebieItem = cart.items.find(item => item.variant_id.toString() === freebieVariantId);
//         if (freebieItem) {
//           fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//               id: freebieItem.key,
//               quantity: 0
//             })
//           }).then(res => res.json()).then(() => setTimeout(updateCartSection, 1000)).catch(error => console.error('Error removing freebie:', error));
//         }
//       }
//       setTimeout(() => {
//         if (typeof updateCartSection === 'function') updateCartSection();
//         cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//       }, 3200);
//     }).catch(error => console.error('Error fetching cart:', error));
//   }, 500)
// }

// window.remove_novology_freebie = function() {
//   console.log("removeFreebie function call");
//   cstmCartDrawerWrapper?.classList.add('cart-items-disabled');
//   const novology_freebieElement = document.getElementById('cart_novology_variant_id');
//   const novology_mainProductElement = document.getElementById('cart_novology_main_product_variant_id');
//   if (!novology_freebieElement || !novology_mainProductElement) return;
//   const novology_freebieVariantId = novology_freebieElement.dataset.variantId;
//   const novology_mainVariantIds = novology_mainProductElement.dataset.variantId.split(',');
//   setTimeout(function() {
//     fetch('/cart.js').then(res => res.json()).then(cart => {
//       const novology_hasMainVariant = cart.items.some(item => novology_mainVariantIds.includes(item.variant_id.toString()));
//       const novology_hasFreebie = cart.items.some(item => item.variant_id.toString() === novology_freebieVariantId);
//       if (!novology_hasMainVariant && novology_hasFreebie) {
//         const freebieItem = cart.items.find(item => item.variant_id.toString() === novology_freebieVariantId);
//         if (freebieItem) {
//           fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//               id: freebieItem.key,
//               quantity: 0
//             })
//           }).then(res => res.json()).then(() => setTimeout(updateCartSection, 1000)).catch(error => console.error('Error removing freebie:', error));
//         }
//       }
//       setTimeout(() => {
//         if (typeof updateCartSection === 'function') updateCartSection();
//         cstmCartDrawerWrapper?.classList.remove('cart-items-disabled');
//       }, 3200);
//     }).catch(error => console.error('Error fetching cart:', error));
//   }, 500)
// }

function updateCartSection() {
  const currentCart = document.querySelector('#CartDrawer');
  if (!currentCart) return;
  const url = `${routes.cart_url}?section_id=cart-drawer&t=${Date.now()}`;
  fetch(url).then(response => response.text()).then(responseText => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const updatedCart = html.querySelector('#CartDrawer');
    const cartWrapper = document.querySelector('.cstm_cart_drawer_wrapper');
    const cartbubble = document.querySelector('.cart-count-bubble');
    if (updatedCart && currentCart) {
      currentCart.innerHTML = updatedCart.innerHTML;
      // Check if cart is empty
      const isCartEmpty = updatedCart.innerText.includes('Your cart is empty'); // Adjust if your theme uses different text
      if (isCartEmpty) {
        cartWrapper?.classList.add('is-empty');
        if (cartbubble) {
          cartbubble.style.display = 'none';
          cartbubble.innerText = '';
        }
      } else {
        cartWrapper?.classList.remove('is-empty');
        // Update cart count bubble
        const updatedCount = html.querySelector('[data-cart-count]');
        if (updatedCount && cartbubble) {
          const count = parseInt(updatedCount.getAttribute('data-cart-count')) || 0;
          if (count > 0) {
            cartbubble.innerText = count;
            cartbubble.style.display = 'flex';
          } else {
            cartbubble.style.display = 'none';
            cartbubble.innerText = '';
          }
        }
      }
      // Re-run freebie logic after DOM update
      setTimeout(() => {
        // freebieUpdate();
      }, 100);
    } else {
      console.warn('CartDrawer element not found in updated DOM.');
    }
  }).catch(error => console.error('Error updating cart section:', error));
}
/*-------cart freebie product add code ends------*/ 
